__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@kne/huawei";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@kne/local-storage", "0.1.0", () => (__webpack_require__.e(416).then(() => (() => (__webpack_require__(4416))))));
			register("@kne/react-fetch", "1.5.5", () => (Promise.all([__webpack_require__.e(732), __webpack_require__.e(300), __webpack_require__.e(201), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(3201))))));
			register("@kne/remote-loader", "1.3.1", () => (Promise.all([__webpack_require__.e(732), __webpack_require__.e(601), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(8601))))));
			register("@kne/use-control-value", "0.1.9", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(331)]).then(() => (() => (__webpack_require__(2331))))));
			register("antd", "5.24.3", () => (Promise.all([__webpack_require__.e(972), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(469)]).then(() => (() => (__webpack_require__(2972))))));
			register("axios", "1.8.3", () => (__webpack_require__.e(344).then(() => (() => (__webpack_require__(4344))))));
			register("dayjs", "1.11.13", () => (__webpack_require__.e(446).then(() => (() => (__webpack_require__(446))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(884)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "6.30.0", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(884), __webpack_require__.e(486)]).then(() => (() => (__webpack_require__(3245))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("use-debounce", "10.0.4", () => (Promise.all([__webpack_require__.e(884), __webpack_require__.e(970)]).then(() => (() => (__webpack_require__(2970))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};